import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

const token = localStorage.getItem("iah_token");
if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export const setToken = (t) => {
  if (t) {
    localStorage.setItem("iah_token", t);
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  } else {
    localStorage.removeItem("iah_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

// Resolve image URLs: absolute stays, /api/... gets backend prefix
export const img = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
};

export const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default api;
